var HtmlComponent_default = {
  "htmlComponent": "_4Ub0k",
  "htmlComponent_placeholder": "nCz72"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
